import { ServiceKind } from "@bitory-gmbh/bsm";
import { ProcessServiceKinds } from "@/services/backend/services/types/kinds";
import { useServiceKindList } from "./use-service-kind-list";

/**
 * useProcessServiceKindList returns the {@link ProcessServiceKinds}
 * available to the user, see {@link useServiceKindList}.
 */
export function useProcessServiceKindList(): ServiceKind[] {
  const available = useServiceKindList();

  return ProcessServiceKinds.filter((kind) => available.includes(kind));
}
